import React from "react";

import NavigationMenu from "../navigationMenu/navigationMenu.component";

import { StyledWrapper } from "./leftNavigationWrapper.style";

const LeftNavigationWrapper = (props) => {
  return (
    <StyledWrapper>
      <NavigationMenu />
      {props.children}
    </StyledWrapper>
  );
};

export default LeftNavigationWrapper;
